export function parseCompletionKeywords(webPlayInfoResp) {
  if (!webPlayInfoResp.completionKeywords) {
    return null
  }
  if (webPlayInfoResp.enableFunnelView) {
    return null
  }
  const tags = webPlayInfoResp.completionKeywords
    .split(';')
    .map(x => (x ? x.trim().toLowerCase() : null))
    .filter(x => x)
  return new Set(tags)
}

export function checkCompletionKeywords(actualKeywords, completionKeywords) {
  return (
    !completionKeywords ||
    !completionKeywords.size ||
    (actualKeywords && actualKeywords.length > 0 && actualKeywords.some(x => completionKeywords.has(x.toLowerCase())))
  )
}
